// ----------------------------------------------------------------------
// <copyright file="Izenda.Performance.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var m = require('mobx');
  var trackable = require('share/tracking/Izenda.Trackable');
  var commonMessages = require('share/messages/Izenda.CommonMessages');
  var localizer = require('share/localization/Izenda.Localizer');
  var { isObject } = require('lodash/fp');

  function Performance() {
    var props = {
      queryTimeoutValue: 0,
      useNoLockValue: false,
      dataSourceLimitValue: 0,
      fieldLimitValue: 0,
      queryLimitValue: 0,
      pivotColumnLimitValue: 0,

      queryTimeoutDefaultValue: 0,
      useNoLockDefaultValue: true,
      dataSourceLimitDefaultValue: 0,
      fieldLimitDefaultValue: 0,
      pivotColumnLimitDefaultValue: 0,
      queryLimitDefaultValue: 0,
      filterLimitValue: 0,
      filterLimitDefaultValue: 0,
      alertMessage: commonMessages.EMPTY_MESSAGE,
      modified: null
    };

    m.extendObservable(trackable(this), props);
  }

  /**
   * Read performance data and fill to props
   * @param {object} result
   */
  Performance.prototype.readPerformanceData = m.action(function(result) {
    result = result || {};

    this.queryTimeoutValue = parseInt(result.queryTimeoutValue);
    this.useNoLockValue = result.useNoLockValue;
    this.dataSourceLimitValue = parseInt(result.dataSourceLimitValue);
    this.fieldLimitValue = parseInt(result.fieldLimitValue);
    this.queryLimitValue = parseInt(result.queryLimitValue);
    this.pivotColumnLimitValue = parseInt(result.pivotColumnLimitValue);
    this.filterLimitValue = parseInt(result.filterLimitValue);

    // Default value
    this.queryTimeoutDefaultValue = parseInt(result.queryTimeoutDefaultValue);
    this.useNoLockDefaultValue = result.useNoLockDefaultValue;
    this.dataSourceLimitDefaultValue = parseInt(result.dataSourceLimitDefaultValue);
    this.fieldLimitDefaultValue = parseInt(result.fieldLimitDefaultValue);
    this.queryLimitDefaultValue = parseInt(result.queryLimitDefaultValue);
    this.pivotColumnLimitDefaultValue = parseInt(result.pivotColumnLimitDefaultValue);
    this.filterLimitDefaultValue = parseInt(result.filterLimitDefaultValue);

    this.modified = result.modified;

    // Reset Dirty
    this.resetDirty();
    return null;
  });

  /**
   * Update new value
   * @param  {[type]} key    [description]
   * @param  {[type]} value) [description]
   * @return {[type]}        [description]
   */
  Performance.prototype.updateValue = m.action(function(key, value) {
    switch (key) {
      case 'queryTimeout':
        this.queryTimeoutValue = parseInt(value) || 0;
        break;
      case 'useNoLock':
        this.useNoLockValue = value;
        break;
      case 'dataSourceLimit':
        this.dataSourceLimitValue = parseInt(value) || 0;
        break;
      case 'fieldLimit':
        this.fieldLimitValue = parseInt(value) || 0;
        break;
      case 'queryLimit':
        this.queryLimitValue = parseInt(value) || 0;
        break;
      case 'pivotColumnLimit':
        this.pivotColumnLimitValue = parseInt(value) || 0;
        break;
      case 'filterLimit':
        this.filterLimitValue = parseInt(value) || 0;
        break;
    }

    this.markDirty();
  });

  /**
   * Reset default value
   * @param  {[type]} key) [description]
   * @return {[type]}      [description]
   */
  Performance.prototype.resetValue = m.action(function(key) {
    switch (key) {
      case 'queryTimeout':
        this.queryTimeoutValue = this.queryTimeoutDefaultValue;
        break;
      case 'useNoLock':
        this.useNoLockValue = this.useNoLockDefaultValue;
        break;
      case 'dataSourceLimit':
        this.dataSourceLimitValue = this.dataSourceLimitDefaultValue;
        break;
      case 'fieldLimit':
        this.fieldLimitValue = this.fieldLimitDefaultValue;
        break;
      case 'queryLimit':
        this.queryLimitValue = this.queryLimitDefaultValue;
        break;
      case 'pivotColumnLimit':
        this.pivotColumnLimitValue = this.pivotColumnLimitDefaultValue;
        break;
      case 'filterLimit':
        this.filterLimitValue = this.filterLimitDefaultValue;
        break;
    }

    this.markDirty();
  });

  /**
   * Build data for save
   */
  Performance.prototype.buildSaveData = function(tenantId) {
    return {
      queryTimeoutValue: this.queryTimeoutValue,
      useNoLockValue: this.useNoLockValue,
      dataSourceLimitValue: this.dataSourceLimitValue,
      fieldLimitValue: this.fieldLimitValue,
      queryLimitValue: this.queryLimitValue,
      pivotColumnLimitValue: this.pivotColumnLimitValue,
      filterLimitValue: this.filterLimitValue,
      tenantId: tenantId,
      modified: this.modified
    };
  };

  /**
   * Show error when value over limited
   */
  Performance.prototype.showErrorWhenOverLimited = function(name, value) {
    this.alertMessage = {
      type: 'info',
      message: String.format(localizer.getText('COMMON_MESSAGES_NUMBER_SMALLER'), name, value)
    };
  };

  /**
   * Reset error message
   */
  Performance.prototype.resetErrorMessage = function() {
    this.alertMessage = commonMessages.EMPTY_MESSAGE;
  };

  /**
   * Show alert message after save
   */
  Performance.prototype.showAlertMessage = function(result) {
    var message = localizer.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED');
    if (!result.success) {
      var messageData = result.messages[0];
      if (isObject(messageData)) {
        message = messageData.messages;
      } else {
        message = messageData;
      }
    }
    this.alertMessage = {
      type: result.success ? 'success' : 'error',
      message: message
    };
    return null;
  };

  module.exports = Performance;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.Performance.js